<template>
  <div class="digitRoll-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <!--        <el-collapse-item-->
        <!--          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"-->
        <!--          title="位置尺寸"-->
        <!--          name="1"-->
        <!--        >-->
        <!--          <div class="setting-item clearFloat mb16">-->
        <!--            <widthAndSizeAndZindex :options="options" :ids="ids" />-->
        <!--           -->
        <!--          </div>-->
        <!--        </el-collapse-item>-->
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="组件风格"
          name="2"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="options mb8">主题样式</div>
            <div class="content">
              <el-radio-group v-model="bgColorType" class="mb16 numberConmpentType">
                <el-radio class="mt8" v-for="(themeStyle, index) in themeStyles" :key="index" :label="themeStyle">{{
                  themeStyle
                }}</el-radio>
              </el-radio-group>
              <div v-if="bgColorType === '纯色'" class="content-item">
                <div>
                  <div class="fs14 mb8">主题颜色</div>
                  <div class="color-picker-container custom-text-bg" style="width: 100%">
                    <el-color-picker class="" v-model="bgColor" color-format="rgb" :show-alpha="true"></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ bgColor }}</span>
                  </div>
                </div>
              </div>
              <div v-if="bgColorType === '渐变'" class="content-item">
                <div class="mb8">
                  <span class="mr16 fs14">开始颜色</span>
                  <div class="color-picker-container custom-text-bg custom-text-bg-jb">
                    <el-color-picker
                      class=""
                      v-model="bgStartColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ bgStartColor }}</span>
                  </div>
                </div>
                <div>
                  <span class="mr16 fs14">结束颜色</span>
                  <div class="color-picker-container custom-text-bg custom-text-bg-jb">
                    <el-color-picker
                      class=""
                      v-model="bgEndColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ bgEndColor }}</span>
                  </div>
                </div>
                <div class="slider-input-container mt8 paddingl0">
                  <span class="mr16 fs14">渐变角度</span>
                  <el-slider
                    :show-tooltip="false"
                    class="mr16"
                    style="width: 60px; height: 4px"
                    v-model="bgColorlinearGradientAngle"
                    :max="360"
                    :min="0"
                  ></el-slider>
                  <single-input
                    style="width: 60px; height: 28px"
                    :value.sync="bgColorlinearGradientAngle"
                    :max="360"
                    inputSuffixs="度"
                  />
                </div>
              </div>
              <div v-if="bgColorType === '边框'" class="content-item">
                <div class="fs14 mb8">主题颜色</div>
                <div class="color-picker-container">
                  <el-color-picker
                    class=""
                    v-model="borderColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ borderColor }}</span>
                </div>
              </div>
              <div v-if="bgColorType === '图片'" class="content-item">
                <img-upload-simple :imgSrc.sync="bgImage" />
              </div>
              <div v-if="bgColorType === '无'" class="content-item"></div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="文字样式"
          name="3"
        >
          <collapsibleItem>
            <div slot="heading">数字设置</div>
            <div slot="body" class="">
              <div class="mb8 mt8">展示方式</div>
              <div class="data-source-type mb16 verticallyCenter">
                <el-radio v-model="isFixed" :label="labelTrue">固定展示</el-radio>
                <el-radio v-model="isFixed" :label="labelFalse">自适应展示</el-radio>
              </div>
              <div class="" v-if="isFixed">
                <div class="mt16 mb8">对齐方式</div>
                <div class="data-source-type mb16 verticallyCenter">
                  <el-radio v-model="digitRollTextAlign" label="left">居左</el-radio>
                  <el-radio v-model="digitRollTextAlign" label="center">居中</el-radio>
                  <el-radio v-model="digitRollTextAlign" label="right">居右</el-radio>
                </div>
              </div>
              <div class="mb16" v-if="isFixed">
                <div class="mb8">默认数字宽度</div>
                <slider-and-input
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="numberWidth"
                  :sliderMax="sliderMaxMargin"
                  suffix="px"
                />
              </div>
              <div class="mb16">
                <div class="mb8">小数保留</div>
                <slider-and-input
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="decimal"
                  :sliderMax="sliderMaxDecimal"
                  suffix="位"
                />
              </div>
              <div class="mb8">文字样式</div>
              <text-setting-update
                class="nextlinemt8"
                :fontColor.sync="fontColor"
                :fontFamily.sync="fontFamily"
                :fontSize.sync="fontSize"
                :fontWeight.sync="fontWeight"
              />
              <div class="mt16">数字间隔</div>
              <slider-and-input
                class="mb8"
                inputWidth="small"
                inputHeight="small"
                :value.sync="marginRight"
                :sliderMax="sliderMaxMargin"
                suffix="px"
              />
              <el-checkbox class="mt16" v-model="showThousandSeparator">显示千位分隔符</el-checkbox>
              <el-checkbox class="mt16 mb8" v-model="showSeparatorBackground">显示分隔符背景</el-checkbox>
            </div>
          </collapsibleItem>
          <collapsibleItem>
            <div slot="heading">前缀设置</div>
            <div slot="body" class="">
              <el-checkbox v-model="showPrefix">显示前缀</el-checkbox>
              <div v-if="showPrefix">
                <div class="mb8 mt16">文字内容</div>
                <el-input v-model="prefixContent" placeholder="请输入"></el-input>
                <div class="mb8 mt16">文字样式</div>
                <text-setting-update
                  class="nextlinemt8"
                  :fontColor.sync="prefixFontColor"
                  :fontFamily.sync="prefixFontFamily"
                  :fontSize.sync="prefixFontSize"
                  :fontWeight.sync="prefixFontWeight"
                />
                <div class="mt16">
                  <div class="mb8">{{ isFixed ? "文字上边距" : "文字下边距" }}</div>
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="prefixFontMarginBottom"
                    :sliderMax="sliderMaxMargin"
                    suffix="px"
                  />
                </div>
                <div class="mt16">
                  <div class="mb8">文字和数字距离</div>
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="prefixFontMarginRight"
                    :sliderMax="sliderMaxMargin"
                    suffix="px"
                  />
                </div>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem>
            <div slot="heading">后缀设置</div>
            <div slot="body" class="">
              <el-checkbox v-model="showSuffix">显示后缀</el-checkbox>
              <div v-if="showSuffix">
                <div class="mb8 mt16">文字内容</div>
                <el-input v-model="suffixContent" placeholder="请输入"></el-input>
                <div class="mb8 mt16">文字样式</div>
                <text-setting-update
                  class="nextlinemt8"
                  :fontColor.sync="suffixFontColor"
                  :fontFamily.sync="suffixFontFamily"
                  :fontSize.sync="suffixFontSize"
                  :fontWeight.sync="suffixFontWeight"
                />
                <div class="mt16">
                  <div class="mb8">{{ isFixed ? "文字上边距" : "文字下边距" }}</div>
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="suffixFontMarginBottom"
                    :sliderMax="sliderMaxMargin"
                    suffix="px"
                  />
                </div>
                <div class="mt16">
                  <div class="mb8">文字和数字距离</div>
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="suffixFontMarginLeft"
                    :sliderMax="sliderMaxMargin"
                    suffix="px"
                  />
                </div>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem>
            <div slot="heading">图标设置</div>
            <div slot="body" class="">
              <el-checkbox v-model="showIcon">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="showIcon">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="iconSrc"
                  :iconType.sync="iconType"
                  :iconColor.sync="iconColor"
                  :resInfo.sync="resInfo"
                />
                <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="iconPosition">
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
                  </cx-color-picker>
                </div>

                <slider-and-input class="mb16" :value.sync="iconSize" title="大小" :sliderMax="100" suffix="px" />
                <slider-and-input
                  class="mb16"
                  :value.sync="iconMargin"
                  title="间距"
                  :sliderMax="sliderMaxMargin"
                  suffix="px"
                />
                <slider-and-input
                  :value.sync="iconMarginBottom"
                  :title="isFixed ? '上边距' : '下边距'"
                  :sliderMax="sliderMaxMargin"
                  suffix="px"
                />
              </div>
            </div>
          </collapsibleItem>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="动画设置"
          name="4"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
            <div>
              <div class="mb8 mt8">动画效果</div>
              <div class="data-source-type mb16 verticallyCenter">
                <el-radio v-model="scrollBounce" :label="bounceTrue">跳动</el-radio>
                <el-radio v-model="scrollBounce" :label="bounceFalse">滚动</el-radio>
              </div>
            </div>
            <div class="">
              <div class="mb8">动画间隔时间</div>
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="animateInterval"
                :sliderMax="sliderMaxInterval"
                suffix="秒"
              />
            </div>
            <div class="mt16">
              <div class="mb8">动画持续时间</div>
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="animateDuration"
                :sliderMax="sliderMaxContinued"
                suffix="秒"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="外观" name="5">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
// import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import CollapsibleItem from "modules/components/collapsibleItem"
import $ from "jquery"
export default {
  name: "digitRoll-options-setting",
  components: {
    CollapsibleItem,
    // widthAndSizeAndZindex,
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5"],
      labelTrue: true,
      labelFalse: false,
      this1: this,
      collapseActiveNames: ["1", "2", "3", "4", "5"],
      sliderMax: 360,
      sliderMaxDecimal: 10,
      sliderMaxMargin: 200,
      sliderMaxContinued: 10,
      sliderMaxInterval: 1000,
      fontFamilyList: [
        {
          value: "默认",
          label: "default"
        },
        {
          value: "默认字体",
          label: "PingFang SC"
        }
      ],
      themeStyles: ["纯色", "渐变", "边框", "图片", "无"],
      bounceTrue: true,
      bounceFalse: false
    }
  },
  comments: {},
  created() {},

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontColor", false)
      }
    },
    bgColorType: {
      get() {
        return this.options.bgColorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorType", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    bgColorlinearGradientAngle: {
      get() {
        return this.options.bgColorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "bgColorlinearGradientAngle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    isFixed: {
      get() {
        return !!this.options.isFixed ? true : false
      },
      set(newVal) {
        if (newVal) {
          const temp = $(".d-roll-item").css("width")
          this.$changeOptionsEV([parseInt(temp), newVal], ["numberWidth", "isFixed"], false)
        } else {
          this.$changeOptionsEV(newVal, "isFixed", false)
        }
      }
    },
    numberWidth: {
      get() {
        return this.options.numberWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "numberWidth", false)
      }
    },
    decimal: {
      get() {
        return this.options.decimal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "decimal", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    showThousandSeparator: {
      get() {
        return this.options.showThousandSeparator
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showThousandSeparator", false)
      }
    },
    showSeparatorBackground: {
      get() {
        return this.options.showSeparatorBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showSeparatorBackground", false)
      }
    },
    showPrefix: {
      get() {
        return this.options.showPrefix
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showPrefix", false)
      }
    },
    prefixContent: {
      get() {
        return this.options.prefixContent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixContent", false)
      }
    },
    prefixFontFamily: {
      get() {
        return this.options.prefixFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixFontFamily", false)
      }
    },
    prefixFontSize: {
      get() {
        return this.options.prefixFontSize
      },
      set(newVal) {
        console.log("inini", typeof newVal)
        this.$changeOptionsEV(newVal, "prefixFontSize", false)
      }
    },
    prefixFontWeight: {
      get() {
        return this.options.prefixFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixFontWeight", false)
      }
    },
    prefixFontColor: {
      get() {
        return this.options.prefixFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixFontColor", false)
      }
    },
    prefixFontMarginBottom: {
      get() {
        return this.options.prefixFontMarginBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixFontMarginBottom", false)
      }
    },
    prefixFontMarginRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "prefixFontMarginRight", "prefixFontMarginRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "prefixFontMarginRight", false)
      }
    },
    suffixFontMarginLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "suffixFontMarginLeft", "suffixFontMarginLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontMarginLeft", false)
      }
    },
    digitRollTextAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "digitRollTextAlign", "digitRollTextAlign", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "digitRollTextAlign", false)
      }
    },
    showSuffix: {
      get() {
        return this.options.showSuffix
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showSuffix", false)
      }
    },
    suffixContent: {
      get() {
        return this.options.suffixContent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixContent", false)
      }
    },
    suffixFontFamily: {
      get() {
        return this.options.suffixFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontFamily", false)
      }
    },
    suffixFontSize: {
      get() {
        return this.options.suffixFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontSize", false)
      }
    },
    suffixFontWeight: {
      get() {
        return this.options.suffixFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontWeight", false)
      }
    },
    suffixFontColor: {
      get() {
        return this.options.suffixFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontColor", false)
      }
    },
    suffixFontMarginBottom: {
      get() {
        return this.options.suffixFontMarginBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "suffixFontMarginBottom", false)
      }
    },
    animateInterval: {
      get() {
        return this.options.animateInterval
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateInterval", false)
      }
    },
    animateDuration: {
      get() {
        return this.options.animateDuration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateDuration", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    bgImage: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "bgImage", "bgImage", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgImage", false)
      }
    },
    scrollBounce: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "scrollBounce", "scrollBounce", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scrollBounce", false)
      }
    },
    showIcon: {
      get() {
        return this.options.showIcon || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType || "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconSize: {
      get() {
        return this.options.iconSize || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSize", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor || "rgba(0,0,0,0.4)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.iconPosition || "right"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconMarginBottom: {
      get() {
        return this.options.iconMarginBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMarginBottom", false)
      }
    },
    resInfo: {
      get() {
        return this.options.resInfo || {}
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.color-picker-container.custom-text-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.color-picker-container.custom-text-bg-jb {
  width: calc(100% - 72px);
}

.slider-input-container.paddingl0 {
  padding-left: 0;
}

.numberConmpentType ::v-deep.el-radio {
  margin-right: 19px;
  &:nth-child(5n) {
    margin-right: 0;
  }
}

.numberConmpentType ::v-deep.el-radio__label {
  padding-left: 4px;
}
.el-radio {
  margin-right: 20px;
}
</style>
